import { useState, useEffect, useRef } from 'react';

export function useCountUp(end, { duration = 1200, delay = 0, decimals = 0 } = {}) {
  const [value, setValue] = useState(0);
  const startTime = useRef(null);
  const rafId = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      startTime.current = performance.now();

      const animate = (now) => {
        const elapsed = now - startTime.current;
        const progress = Math.min(elapsed / duration, 1);

        // ease-out cubic
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = eased * end;

        setValue(Number(current.toFixed(decimals)));

        if (progress < 1) {
          rafId.current = requestAnimationFrame(animate);
        }
      };

      rafId.current = requestAnimationFrame(animate);
    }, delay);

    return () => {
      clearTimeout(timeout);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [end, duration, delay, decimals]);

  return value;
}
